import React from 'react';
import BouncingWords
    from "../../components/bouncingWords/bouncingWords";
import BouncingWordsMessage
    from "../../components/bouncingWordsMessage/bouncingWordsMessage";
import './bouncingWordsPage.css';

const BouncingWordsPage = ({message}) => {
    return (
        <div className={"thankYouPageWrapper"}>
            <BouncingWords numWords={50} maxLength={7} fullscreen randomColour />
            <BouncingWordsMessage message={message}/>
        </div>
    )
}

export default BouncingWordsPage